export default {
  computed: {
    ocrControlQuickFilters() {
      return {
        title: this.$gettext('Shipment Files OCR'),
        filters: {
          columns: [
            {
              class: 'col-12 col-sm-4 col-lg-2',
              filters: [
                {
                  name: 'shipping-files-review-status',
                  label: this.$gettext('Review Status'),
                  type: 'radio-group',
                  value: 'manual',
                  stacked: true,
                  options: [
                    {
                      text: this.$gettext('Pending OCR'),
                      value: null
                    },
                    {
                      text: this.$gettext('Automatic'),
                      value: 'automatic'
                    },
                    {
                      text: this.$gettext('Need Review'),
                      value: 'manual'
                    },
                    {
                      text: this.$gettext('Reviewed'),
                      value: 'reviewed'
                    }
                  ],
                  callback: (val) => {
                    if (val || val === null) {
                      return [[ 'content_status', 'eq', val ]]
                    } else {
                      return []
                    }
                  }
                }
              ]
            },
            {
              class: 'col-12 col-md-6 col-lg-4',
              filters: [
                {
                  name: 'shipping-files-shipping-id',
                  label: this.$gettext('Shipment ID'),
                  type: 'text',
                  value: '',
                  callback: (val) => {
                    if (val.length > 0) {
                      return [[ 'shipping_id', 'sw', val.trim() ]]
                    } else {
                      return []
                    }
                  }
                },
                {
                  name: 'shipping-files-created-at',
                  label: this.$gettext('Created At Date Range'),
                  type: 'daterange',
                  opens: 'center',
                  value: {
                    startDate: this.moment().tz(this.$tz).startOf('day').utc().subtract(3, 'days').toDate(),
                    endDate: this.moment().tz(this.$tz).endOf('day').utc().toDate(),
                    dateRangeActive: true
                  },
                  callback: (val) => {
                    if (val.dateRangeActive) {
                      const range = [
                        this.moment(val.startDate).tz(this.$tz).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss'),
                        this.moment(val.endDate).tz(this.$tz).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')
                      ]
                      return [[ 'created_at', 'bt', range ]]
                    } else {
                      return []
                    }
                  }
                }
              ]
            }
          ]
        }
      }
    }
  }
}
